<nz-modal
  [(nzVisible)]="isVisible"
  (nzOnCancel)="modalCancel()"
  (nzOnOk)="modalOk()"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  nzMaskClosable="false"
  >
  <ng-template #modalTitle>
    <h1 class="modal-header">My Job Alerts</h1>
  </ng-template>
  <ng-template #modalContent>
    @if (jobAlerts.length === 0) {
      <div class="center-container">
        <img
          src="../../assets/images/no-results-found.svg"
          alt="no saved job alert"
          />
          <h3>No saved job alert</h3>
        </div>
      }
      @for (
        jobAlert of jobAlerts; track
        jobAlert; let idx = $index; let last = $last; let first = $first) {
        @if (indexOnEdit === -1) {
          <div nz-row [nzGutter]="16">
            <div
              nz-col
              nzXs="20"
              nzSm="21"
              nzMd="21"
              nzLg="21"
              class="gutter-row"
              >
              <div>
                <a [routerLink]="['/job-list']" [queryParams]="jobAlert.queryParams" class="job-title"
                  ><span>{{ jobAlert.jobAlertName }}</span>
                </a>
              </div>
            </div>
            <div nz-col nzXs="4" nzSm="3" nzMd="3" nzLg="3" class="gutter-row">
              @if (indexOnEdit === -1) {
                <a (click)="edit(idx)"><i class="fa-regular fa-pen fa-lg"></i></a>
                <a (click)="delete(jobAlert.id)"
                  ><i
                  class="fa-regular fa-trash fa-lg"
                  style="color: #e8212b; margin-left: 10px"
                  ></i
                ></a>
              }
            </div>
          </div>
        }
        @if (idx === indexOnEdit) {
          <app-job-alert-form [data]="jobAlert"
            [dataList]="jobAlerts"
            (closeForm)="cancel()"
           />
        }
        @if (indexOnEdit === -1 && jobAlerts?.length > 1 && !last) {
          <nz-divider />
        }
      }
    </ng-template>

    <ng-template #modalFooter>
      @if (indexOnEdit === -1) {
        <button
          nz-button
          nzType="primary"
          nzShape="round"
          nzSize="large"
          (click)="modalOk()"
          >
          Done
        </button>
      }
    </ng-template>
  </nz-modal>
